import React, { forwardRef } from 'react'
import { CalendarBlankIcon, XIcon } from '@phosphor-icons/react'

interface DateFieldInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  success?: boolean
  error?: boolean
  clearable?: boolean
  onClear?: () => void
}

export const DateFieldInput = forwardRef<HTMLInputElement, DateFieldInputProps>(
  ({ success, error, clearable, onClear, value, ...props }, ref) => {
    const hasValue = Boolean(value)
    const showClear = clearable && hasValue

    return (
      <div
        className={`employee-form__date-wrapper ${
          showClear ? 'employee-form__date-wrapper--clearable' : ''
        }`}
      >
        <input
          {...props}
          value={value}
          ref={ref}
          className={`employee-form__input employee-form__date-input ${
            success ? 'employee-form__input--success' : ''
          } ${error ? 'employee-form__input--error' : ''}`}
        />
        <span className="employee-form__date-icon" aria-hidden="true">
          <CalendarBlankIcon size={14} weight="regular" />
        </span>
        {showClear ? (
          <button
            type="button"
            className="employee-form__date-clear"
            aria-label="Clear date"
            onClick={e => {
              e.preventDefault()
              e.stopPropagation()
              onClear?.()
            }}
          >
            <XIcon size={14} weight="bold" />
          </button>
        ) : null}
      </div>
    )
  },
)
DateFieldInput.displayName = 'DateFieldInput'
